import React, { Component } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import { store } from '../stores/mainStore';

import { PreloadAssets } from './PreloadAssets';
import { ProgressBar } from './ProgressBar';
import { integration } from '../integration';
import { Sprite } from './Sprite';
import { preloadB64Images } from './B64Image';

const Bar = styled.div`
	width: 76vw;
	height: 10vw;
	margin-bottom: 7%;
	box-sizing: border-box;
	overflow: hidden;
`;


@observer
export class Preloader extends Component {
	state = {
		lobbyLoad: false,
	};

	componentDidMount() {
		console.log('PREloade mounted')
		integration.postEvent('web_preload_start', 'loading');
		const imagePaths = [
			'/assets/languages/en/splash_msg_loading.png',
			'/assets/languages/en/popup_box_connectionError.png',
			'/assets/popups/panel_blue_small.png',
			'/assets/skillz/hud_siu.png',
			'assets/buttons/icon_gear.png',
			'/assets/buttons/btn_skillz_timer_play_2.png',
			'/assets/buttons/btn_skillz_timer_pause_2.png',
			'assets/buttons/btn_icon_clock.png',
			'assets/buttons/btn_icon_heart_front.png',
			'/assets/lobby/game_lobby_ava.png',
			'/assets/popups/ava_circular.png',
			'/assets/skillz/roll_1_bottom.png',
			'/assets/skillz/cup_bottom.png',
			'/assets/skillz/cup_top.png'
		];
		const onProgress = (percentComplete) => {
			store.reactLoadPercentage = percentComplete;

			if(percentComplete >= 100 && store.fakeLoadPercentage === 0) {
				const dur = 3000, num = 50
				const timer = setInterval(() => {
					if(store.fakeLoadPercentage < 100)
						store.fakeLoadPercentage += 100/num
					else {
						clearTimeout(timer)
					}
				}, dur / num)
			}
		};

		if(store.progressBarShownFirstTime === false) {
			integration.postEvent('splash_loading_bar', 'loading');
			store.progressBarShownFirstTime = true;
		}
		preloadB64Images(imagePaths, onProgress);
	}

	render() {
		return (
			<div style={{ textAlign: 'center' }}>
				<Sprite w={60} h={16} sprite="splash_msg_loading.png" path="/assets/languages/" localize />
				<Bar>
					<ProgressBar percent={store.totalLoadPercentage}></ProgressBar>
				</Bar>
				<PreloadAssets>
					<img alt="" src={`/assets/skillz/custom/${store.custom.table}_hud.png`}/>
				</PreloadAssets>
			</div>
		);
	}
}
